<template>
    <nav class="navbar is-fixed-top px-6" 
        role="navigation" 
        aria-label="main navigation"
        :style="navbarSolid"
    >
        <!-- [TO-DO] reimplementar FID-916 -->
        <!-- style="background: transparent"
        :style="[isTransparent  ? navbarSolid : '']" -->
        <div class="navbar-brand">
            <router-link class="navbar-item" tag="a" :to="{ path: '/' }">
                <img :src="logo_url" contain class="brand-img">
            </router-link>

            <a role="button"
                class="navbar-burger burger"
                aria-label="menu"
                aria-expanded="false"
                :class="burguerClass"
                @click="isActive = !isActive"
            >
                <span :style="computedFont" aria-hidden="true"></span>
                <span :style="computedFont" aria-hidden="true"></span>
                <span :style="computedFont" aria-hidden="true"></span>
            </a>
        </div>

        <div class="navbar-menu mr-6" 
            id="navbar-menu" 
            ref="navbar-menu" 
            :class="menuClass"
        >
            <div class="navbar-end">

                <a class="navbar-item center-button"
                    v-if="!hideCashback && verifiedEmptyArray(prizes)"
                    tag="a" 
                    :style="computedFont"
                    href="#premios"
                    v-smooth-scroll
                >
                    Prêmios
                </a>

                <a class="navbar-item center-button"
                    v-if="verifiedEmptyArray(levels)"
                    tag="a" 
                    :style="computedFont"
                    href="#niveis"
                    v-smooth-scroll
                >
                    Níveis
                </a>

                <a class="navbar-item center-button"
                    tag="a"
                    :style="computedFont"
                    href="#como-funciona"
                    v-smooth-scroll
                >
                    Como funciona
                </a>

                <a class="navbar-item center-button"
                    tag="a"
                    v-if="verifiedEmptyArray(faq.items)"
                    :style="computedFont"
                    href="#FAQ"
                    v-smooth-scroll
                >
                    Dúvidas
                </a>

                     <div class="navbar-item center-button">
                        <div class="buttons">
                            <a tag="a" class="button"
                                :href="frontendUrl"
                                @click="toLogin"
                                :style="computedLogin"
                            >
                                Entrar
                            </a>
                        </div>
                    </div>

                <div class="navbar-item center-button">
                    <div class="buttons">
                        <a class="button" tag="a" 
                            @click="toRegister" 
                            :href="frontendUrl" 
                            :style="computedButtonStyle"
                        >
                            Quero me cadastrar
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Navbar',
    data: vm => ({
        isActive: false,
        // isTransparent : false,
        scrollPosition:0
    }),
    //  [TO-DO] reimplementar FID-916 
    // created () {
    //     window.addEventListener('scroll', this.handleScroll);
    // },
    // destroyed () {
    //     window.removeEventListener('scroll', this.handleScroll);
    // },
    methods: {
        toRegister() {
            window.location = this.frontendUrl
        },
        toLogin() {
            window.location = this.frontendUrl
        },
        //  [TO-DO] reimplementar FID-916 
        // handleScroll(event) {
        //     this.scrollPosition = window.scrollY

        //     if (this.scrollPosition > 500) {
        //         this.isTransparent = true
        //     } else {
        //         this.isTransparent = false
        //     }
        // },
        verifiedEmptyArray(array) {
            const arr = (Array.isArray(array) ? array.filter(item => !this.$lodash.isEmpty(item)) : [])
            return arr.length
        }
    },
    computed: {
        ...mapGetters({
            logo_url        : 'company/logo_url',
            styles          : 'company/landing_page_colors',
            faq             : 'company/faq',
            frontendUrl     : 'company/frontend_domain',
            prizes          : 'prizes/prizes',
            levels          : 'level/levels',
            hideCashback    : 'company/hide_cashback',
        }),

        navbarSolid() {
            return {
                'background':this.styles.nav_background_color,
                'color': this.styles.nav_font_color,
            }
        },

        computedButtonStyle() {
            return {
                'background-color': this.styles.nav_font_color,
                'border-color': this.styles.nav_font_color,
                'color': this.styles.nav_background_color,
                'font-size': '1.125rem',
            }
        },

        computedFont() {
            return {
                'color': this.styles.nav_font_color,
                'font-size': '1.125rem',
            }
        },
        computedLogin() {
            return {
                'color': this.styles.nav_font_color,
                'font-size': '1.125rem',
                'border-color': this.styles.nav_font_color,
                'background': 'transparent',
            }
        },

        menuClass() {
            return {
                'is-active': this.isActive,
            }
        },

        burguerClass() {
            return {
                'is-active': this.isActive,
            }
        },
    },
    watch: {
        '$route.name'() {
            this.isActive = false
        },
    },
}
</script>

<style lang="scss" scoped>
.brand-img {
    height: 100%;
    max-height: unset;

    max-width: 160px;
    max-height: 44px;
}
.center-button {
    display: flex;
    justify-content: center;
}

@media screen and (max-width: 768px) {
    .brand-img {
        display: none;
    }
}

@media screen and (max-width: 1023px) {
    .navbar {
        background-color: rgba(0, 0, 0,.5) !important;
        padding: 0 !important;
    }

    .navbar-brand {
        background-color: rgba(0, 0, 0,.5) !important;
    }

    .navbar-menu {
        background-color: rgba(0, 0, 0,.5) !important;
        width: 100%;
    }

    .navbar-burger{
        margin-left: 0;
    }
}
</style>